import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { modalAnimations } from '@shared/animations/animations';
import { I18nPipe } from '@shared/pipes/i18n.pipe';

@Component({
    selector: 'app-modal-faqs',
    templateUrl: 'modal-faqs.component.html',
    styleUrls: [],
    animations: modalAnimations,
})
export class ModalFaqsComponent implements OnInit {
    @Input() visibility: boolean;
    @Output() visibilityChange = new EventEmitter<boolean>();
    listFaqs: any;
    selectedItem = -1;
    faqQuestionValue: string;
    faqResponseValue: string;
    size = 100;

    constructor(private i18nPipe: I18nPipe) {}

    ngOnInit() {
        this.listFaqs = [];

        for (let index = 1; index < this.size; index++) {
            const currentQuestion =
                'differeddecisionintroduction.faq.question' + index;
            if (this.i18nPipe.i18nData[currentQuestion]) {
                this.faqQuestionValue =
                    this.i18nPipe.transform(currentQuestion);
                this.faqResponseValue = this.i18nPipe.transform(
                    currentQuestion + '.answer'
                );
                if (this.faqResponseValue !== currentQuestion + '.answer') {
                    const object = {
                        id: index,
                        question: this.faqQuestionValue,
                        answer: this.faqResponseValue,
                    };
                    this.listFaqs.push(object);
                }
            }
        }
    }

    closeFaqModal() {
        this.visibility = false;
        this.visibilityChange.emit(this.visibility);
    }

    selectItem(item) {
        this.selectedItem = this.selectedItem !== item ? item : -1;
    }

    questionIsOpen(item) {
        return this.selectedItem === item;
    }
}
